import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import { Paragraph } from "@zendeskgarden/react-typography"
import ArrowLink from "./arrowLink"

const Heading = styled.h2`
  margin-bottom: ${props => props.theme.space.sm};
  font-weight: ${props => props.theme.fontWeights.semibold};
  font-size: ${props => props.theme.fontSizes.lg};
  line-height: ${props => props.theme.lineHeights.lg};
`

const Description = styled(Paragraph)`
  margin-bottom: ${props => props.theme.space.sm};
`

const FeatureBlock = ({ heading, description, linkText, linkHref }) => (
  <div>
    <Heading>{heading}</Heading>
    <Description>{description}</Description>
    <ArrowLink href={linkHref}>{linkText}</ArrowLink>
  </div>
)

FeatureBlock.propTypes = {
  heading: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  linkText: PropTypes.string.isRequired,
  linkHref: PropTypes.string.isRequired
}

export default FeatureBlock
